import styled from 'styled-components';

export const BadgesWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: ${({ $tone }) => {
    if ($tone === 'ok') return 'rgba(46,170,199,0.18)';
    if ($tone === 'warn') return '#ea4335';
    return 'rgba(255,255,255,0.08)';
  }};
  color: ${({ $tone }) => {
    if ($tone === 'ok') return '#7de3f2';
    if ($tone === 'warn') return '#ffffff';
    return '#d6e2ed';
  }};
`;

export const StatusIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
`;

export const IconBadgeButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px;
  height: 32px;
  gap: 0;
  padding: 0;
  border-radius: 999px;
  background: ${({ $tone }) => {
    if ($tone === 'ok') return 'rgba(46,170,199,0.18)';
    if ($tone === 'warn') return '#ea4335';
    return 'rgba(255,255,255,0.08)';
  }};
  color: ${({ $tone }) => {
    if ($tone === 'ok') return '#7de3f2';
    if ($tone === 'warn') return '#ffffff';
    return '#d6e2ed';
  }};

  svg {
    width: 20px;
    height: 20px;
    font-weight: 800;
  }
`;